import {parseConfig} from "./config.utils";

export const Config = parseConfig({
    URL_API: process.env.REACT_APP_URL_API,
    PATH_FILE: process.env.REACT_APP_PATH_FILE,
    PROJECT_NAME: process.env.REACT_APP_PROJECT_NAME,
    PUBLIC_BACKEND_IP: process.env.REACT_APP_PUBLIC_BACKEND_IP || '185.30.19.243',
    EDITING_GROUPS_FOR_PERSONAL_MANAGER: Boolean(+process.env.REACT_APP_EDITING_GROUPS_FOR_PERSONAL_MANAGER),
    RATE_PER_TEACHER_ON_CARD: Boolean(+process.env.REACT_APP_RATE_PER_TEACHER_ON_CARD),
});
